(function () {
  function initMediaTabs(container) {
    if (!container || container.dataset.mediaTabsInitialized == 'true') return;
    container.dataset.mediaTabsInitialized = 'true';

    var autoplayEnabled = container.dataset.autoplay === 'true';
    const tabs = container.querySelectorAll('.tab-js');
    const indicator = container.querySelector('[data-media-tabs-indicator]');
    const mediaBlocks = container.querySelectorAll('.media-block-js');
    const textBlocks = container.querySelectorAll('.text-block-js');
    let sectionCanPlay = false;

    function loadVideo(vid) {
      if (!vid || vid.dataset.loaded == 'true') return;

      vid.querySelectorAll('source[data-src]').forEach(source => {
        source.src = source.dataset.src;
      });
      vid.load();
      vid.dataset.loaded = 'true';
    }

    function playVideo(vid, btn) {
      if (!vid) return;
      loadVideo(vid);
      vid.muted = true;
      vid.defaultMuted = true;
      setTimeout(() => {
        vid.play().then(() => {
          if (btn) btn.classList.remove('is-paused');
        }).catch(err => {
          console.warn("Autoplay block:", err);
          if (btn) btn.classList.add('is-paused');
        });
      }, 100);
    }

    function updateMediaTab(activeTab) {
      if (!activeTab) return;
      const targetIndex = activeTab.getAttribute('data-index');

      // 更新 Indicator
      if (indicator) {
        indicator.style.width = activeTab.offsetWidth + 'px';
        indicator.style.left = activeTab.offsetLeft + 'px';
      }

      // 切换视频/图片
      mediaBlocks.forEach(block => {
        const vid = block.querySelector('video');
        const btn = block.querySelector('.video-toggle-js');

        if (block.getAttribute('data-index') === targetIndex) {
          block.classList.add('is-active');
          if (vid && sectionCanPlay && autoplayEnabled) playVideo(vid, btn);
        } else {
          block.classList.remove('is-active');
          if (vid) { vid.pause(); vid.currentTime = 0; }
        }
      });

      // 切换文字内容
      textBlocks.forEach(text => {
        if (text.getAttribute('data-index') === targetIndex) {
          text.classList.add('is-active');
        } else {
          text.classList.remove('is-active');
        }
      });

      tabs.forEach(t => t.classList.remove('is-active'));
      activeTab.classList.add('is-active');
    }

    // 按钮逻辑
    container.querySelectorAll('.video-toggle-js').forEach(btn => {
      const vid = btn.closest('.media-block-js').querySelector('video');
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        if (vid.paused) { loadVideo(vid); vid.play(); btn.classList.remove('is-paused'); }
        else { vid.pause(); btn.classList.add('is-paused'); }
      });
    });

    // Tab 点击
    tabs.forEach(tab => tab.addEventListener('click', () => updateMediaTab(tab)));

    // 初始化
    const activeTab = container.querySelector('.tab-js.is-active');
    if (activeTab) updateMediaTab(activeTab);

    const viewportObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          sectionCanPlay = entry.isIntersecting && entry.intersectionRatio >= 0.2;
          const activeVideo = container.querySelector('.media-block-js.is-active video');
          const activeBtn = container.querySelector('.media-block-js.is-active .video-toggle-js');

          if (sectionCanPlay && activeVideo && autoplayEnabled) {
            playVideo(activeVideo, activeBtn);
          } else {
            container.querySelectorAll('video').forEach(video => video.pause());
          }
        });
      },
      {
        rootMargin: '0px',
        threshold: [0, 0.2],
      }
    );

    viewportObserver.observe(container);
  }

  function scheduleMediaTabs(container) {
    if (!container) return;

    if (!('IntersectionObserver' in window)) {
      initMediaTabs(container);
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          observer.disconnect();
          initMediaTabs(container);
        }
      });
    }, {
      rootMargin: '0px',
      threshold: 0.01,
    });

    observer.observe(container);
    container.addEventListener('pointerdown', function () {
      initMediaTabs(container);
    }, { once: true, passive: true });
  }

  function initAll() {
    document.querySelectorAll('[data-media-tabs-scope]').forEach(scheduleMediaTabs);
  }

  document.addEventListener('shopify:section:load', initAll);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
